<template>
	<div>
		<template v-if="dataType == 'target'">
			<AssociationSelectDialog
				:label="label"
				:required="required"
				:value.sync="metaValue"
				:association_value.sync="associationValue"
				:type="'value_target_type'"
				:id="'value_target_id'"
				:associationName="association_name"
			/>
		</template>
		<template v-else-if="option_type == 'required'">
			<v-select
				v-model="metaValue"
				:label="required ? `${label}（必須）` : label"
				:rules="required ? [rules.required] : []"
				:items="options"
				class="mt-4"
				outlined
				dense
			/>
		</template>
		<template v-else-if="option_type == 'optional'">
			<v-row no-gutters class="flex-nowrap">
				<v-combobox
					v-model="metaValue"
					:label="required ? `${label}（必須）` : label"
					:rules="required ? [rules.required] : []"
					:items="options"
					class="mt-4"
					outlined
					dense
					:hint="
						dataType == 'datetime' || dataType == 'date'
							? ''
							: '選択肢が存在しない場合は入力が可能です。'
					"
					:persistent-hint="dataType != 'datetime' || dataType != 'date'"
				/>
				<template v-if="dataType == 'date'">
					<v-menu
						close-on-content-click
						transition="scale-transition"
						offset-y
						left
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="ml-2 mt-4" color="secondary" dense v-bind="attrs" v-on="on">
								日付選択
							</v-btn>
						</template>
						<v-date-picker class="date-picker" v-model="metaValue" no-title locale="ja-JP">
							<v-spacer></v-spacer>
						</v-date-picker>
					</v-menu>
				</template>
				<template v-if="dataType == 'datetime'">
					<v-menu
						v-model="datetimeMenu"
						max-width="600"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						left
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="ml-2 mt-4" color="secondary" dense v-bind="attrs" v-on="on">
								{{ "日時選択" }}
							</v-btn>
						</template>
						<v-card class="pa-2">
							<v-row no-gutters>
								<v-col cols="12">
									<v-row no-gutters>
										<v-col class="pr-1" cols="4">
											<v-combobox v-model="datetime.year" dense outlined :items="years">
												<template v-slot:append-outer>年</template>
											</v-combobox>
										</v-col>
										<v-col class="px-1" cols="4">
											<v-combobox v-model="datetime.month" dense outlined :items="months">
												<template v-slot:append-outer>月</template>
											</v-combobox>
										</v-col>
										<v-col class="pl-1" cols="4">
											<v-combobox v-model="datetime.day" dense outlined :items="days">
												<template v-slot:append-outer>日</template>
											</v-combobox>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12">
									<v-row no-gutters>
										<v-col class="pr-1" cols="4">
											<v-combobox v-model="datetime.hour" dense outlined :items="hours">
												<template v-slot:append-outer>時</template>
											</v-combobox>
										</v-col>
										<v-col class="px-1" cols="4">
											<v-combobox v-model="datetime.minute" dense outlined :items="minutes">
												<template v-slot:append-outer>分</template>
											</v-combobox>
										</v-col>
										<v-col class="pl-1" cols="4">
											<v-combobox v-model="datetime.second" dense outlined :items="seconds">
												<template v-slot:append-outer>秒</template>
											</v-combobox>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row no-gutters justify="center">
								<v-btn color="secondary" @click="setDatetimeByMenu" :disabled="validDatetime"
									>日時決定</v-btn
								>
							</v-row>
						</v-card>
					</v-menu>
				</template>
			</v-row>
		</template>
		<template v-else-if="option_type == 'not_required'">
			<v-textarea
				v-if="dataType == 'text'"
				v-model="metaValue"
				:label="required ? `${label}（必須）` : label"
				:rules="required ? [rules.required] : []"
				class="mt-4"
				outlined
				dense
			/>
			<v-text-field
				v-if="dataType == 'string'"
				v-model="metaValue"
				:label="required ? `${label}（必須）` : label"
				:rules="required ? [rules.required] : []"
				class="mt-4"
				outlined
				dense
			/>
			<v-text-field
				v-if="dataType == 'integer'"
				v-model="metaValue"
				:label="required ? `${label}（必須）` : label"
				:rules="
					required ? [rules.required, rules.integerWithNegative] : [rules.integerWithNegative]
				"
				class="mt-4"
				outlined
				dense
			/>
			<v-text-field
				v-if="dataType == 'float'"
				v-model="metaValue"
				:label="required ? `${label}（必須）` : label"
				:rules="required ? [rules.required, rules.floatWithNegative] : [rules.floatWithNegative]"
				class="mt-4"
				outlined
				dense
			/>
			<v-radio-group
				v-if="dataType == 'boolean'"
				v-model="metaValue"
				:rules="required ? [rules.required] : []"
				class="mt-4"
				dense
				row
			>
				<v-radio :value="true" class="mx-2" color="secondary" label="⚪">⚪︎</v-radio>
				<v-radio :value="false" class="mx-2 ml-8" color="secondary" label="✖️">×</v-radio>
			</v-radio-group>
			<v-menu
				v-if="dataType == 'date'"
				ref="menu"
				close-on-content-click
				transition="scale-transition"
				offset-y
				min-width="auto"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						:label="required ? `${label}（必須）` : label"
						:rules="required ? [rules.required] : []"
						v-model="metaValue"
						outlined
						dense
						readonly
						v-bind="attrs"
						v-on="on"
						class="mt-4"
					/>
				</template>
				<v-date-picker v-model="metaValue" no-title scrollable locale="ja" />
			</v-menu>
			<v-text-field
				v-if="dataType == 'time'"
				v-model="metaValue"
				:label="required ? `${label}（必須）` : label"
				:rules="required ? [rules.required] : []"
				class="mt-4"
				type="time"
				outlined
				dense
			/>
			<div v-if="dataType == 'datetime'" class="mt-4 datetime-select" outlined dense>
				<h3>
					{{ required ? `${label}（必須）` : label }}
				</h3>
				<v-row class="ma-0 mt-2" justify="space-between">
					<v-select
						v-model="datetime.year"
						:items="years"
						class="px-1"
						label="年"
						:rules="required ? [rules.required] : []"
						dense
						outlined
						@change="setDatetime"
					/>
					<v-select
						v-model="datetime.month"
						:items="months"
						class="px-1"
						label="月"
						:rules="required ? [rules.required] : []"
						dense
						outlined
						@change="setDatetime"
					/>
					<v-select
						v-model="datetime.day"
						:items="days"
						class="px-1"
						label="日"
						:rules="required ? [rules.required] : []"
						dense
						outlined
						@change="setDatetime"
					/>
				</v-row>
				<v-row class="ma-0" justify="space-between">
					<v-select
						v-model="datetime.hour"
						:items="hours"
						class="px-1"
						label="時"
						:rules="required ? [rules.required] : []"
						dense
						outlined
						@change="setDatetime"
					/>
					<v-select
						v-model="datetime.minute"
						:items="minutes"
						class="px-1"
						label="分"
						:rules="required ? [rules.required] : []"
						dense
						outlined
						@change="setDatetime"
					/>
					<v-select
						v-model="datetime.second"
						:items="seconds"
						class="px-1"
						label="秒"
						:rules="required ? [rules.required] : []"
						dense
						outlined
						@change="setDatetime"
					/>
				</v-row>
			</div>
		</template>
	</div>
</template>

<script>
import moment from "moment/min/moment.min.js"
import rules from "../../helper/rules"
import common from "../../helper/common"
import AssociationSelectDialog from "./AssociationSelectDialog.vue"
import SynchronizationForm from "./SynchronizationForm.vue"

export default {
	components: {
		AssociationSelectDialog,
		SynchronizationForm,
	},
	props: {
		dataType: {
			type: String,
			default: "text",
		},
		value: {
			type: null,
		},
		notSync: {
			type: Boolean,
			default: false,
		},
		required: {
			type: Boolean,
			default: false,
		},
		options: {
			type: Array,
			default: () => [],
		},
		label: {
			type: String,
			default: "",
		},
		option_type: {
			type: String,
			default: "not_required",
		},
	},
	data() {
		return {
			rules: rules,
			common: common,
			datetimeMenu: false,
			dialog: false,
			items: [],
			associationValue: "",
			datetime: {
				year: null,
				month: null,
				day: null,
				hour: null,
				minute: null,
				second: null,
			},
		}
	},
	mounted() {
		if (this.dataType == "target" && this.metaValue.value?.label) {
			this.associationValue = this.metaValue.value.label
		}
		if (this.data_type == "date") {
			this.datetime.year = Number(moment(this.metaValue).format("YYYY-MM-DD"))
		}
		if (this.data_type == "time") {
			this.datetime.year = Number(moment(this.metaValue).format("HH:mm"))
		}
		if (this.data_type == "datetime") {
			this.datetime.year = Number(moment(this.metaValue).format("YYYY"))
			this.datetime.month = Number(moment(this.metaValue).format("MM"))
			this.datetime.day = Number(moment(this.metaValue).format("DD"))
			this.datetime.hour = Number(moment(this.metaValue).format("HH"))
			this.datetime.minute = Number(moment(this.metaValue).format("mm"))
			this.datetime.second = Number(moment(this.metaValue).format("ss"))
		}
	},
	methods: {
		setDatetime() {
			if (
				this.datetime.year == null ||
				this.datetime.month == null ||
				this.datetime.day == null ||
				this.datetime.hour == null ||
				this.datetime.minute == null ||
				this.datetime.second == null
			)
				return
			this.metaValue = `${this.datetime.year}-${this.datetime.month}-${this.datetime.day} ${this.datetime.hour}:${this.datetime.minute}:${this.datetime.second}`
		},
		setDatetimeByMenu() {
			this.setDatetime()
			this.datetimeMenu = false
		},
	},
	computed: {
		validDatetime() {
			return (
				this.datetime.year == null ||
				this.datetime.month == null ||
				this.datetime.day == null ||
				this.datetime.hour == null ||
				this.datetime.minute == null ||
				this.datetime.second == null
			)
		},
		years() {
			const thisYear = new Date().getFullYear()
			const endYear = 1900
			const years = [...Array(thisYear - endYear + 1)].map((_, i) => thisYear - i)
			return years
		},
		months() {
			const months = [...Array(12)].map((_, i) => i + 1)
			return months
		},
		days() {
			const days = [...Array(31)].map((_, i) => i + 1)
			return days
		},
		hours() {
			const hours = [...Array(24)].map((_, i) => i)
			return hours
		},
		minutes() {
			const days = [...Array(60)].map((_, i) => i)
			return days
		},
		seconds() {
			const days = [...Array(60)].map((_, i) => i)
			return days
		},
		metaValue: {
			get() {
				return this.value
			},
			set(newValue) {
				if (this.notSync) {
					return this.$emit("update-value", newValue)
				} else {
					return this.$emit("update:value", newValue)
				}
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.datetime-select {
	.v-input {
		width: calc(100% / 3);
		max-width: calc(100% / 3);
	}
}
</style>
